define('templates/template-builder',[],function(){
    
    var TemplateBuilder = function(){};
    
    /**
     * Headers part ---------------------------------
     */
    
    TemplateBuilder.prototype.basicHeader = function( fieldKey, content ){
        return {
            'nodeType':'th',
            'attributes':{'draggable':'true'},
            'data':{'key': fieldKey},
            'content': content
        };
    };

    TemplateBuilder.prototype.basicHeaderWithTitle = function( fieldKey, content, title ){
        var header = this.basicHeader(fieldKey, content);
        header.title = title;
        return header;
    };

    TemplateBuilder.prototype.sortableHeader = function( fieldKey, fieldName, sortKey ){
        return {
            'nodeType':'th',
            'attributes':{'draggable':'true'},
            'data':{'key' : fieldKey},
            'content':
                {
                'nodeType':'div',
                'classes':['table-header'],
                'content':
                    [
                         {
                         'nodeType':'span',
                         'classes':['col-name'],
                         'content': fieldName
                         },
                         {
                         'nodeType':'div',
                         'classes':['page-sort'],
                         'content':
                             [
                              {
                               'nodeType':'a',
                               'classes':['sort-link'],
                               'href':'javascript:void(0);',
                               'data':{'params':'pg=:' + sortKey},
                               'content':
                                   {
                                       'nodeType':'span',
                                       'classes':['icon-caret-up'],
                                       'content':'&nbsp;'
                                   }
                              },
                              {
                              'nodeType':'br'
                              },
                              {
                              'nodeType':'a',
                              'classes':['sort-link'],
                              'href':'javascript:void(0);',
                              'data':{'params':'pg=:-' + sortKey},
                              'content':
                                  {
                                  'nodeType':'span',
                                  'classes':['icon-caret-down'],
                                  'content':'&nbsp;'
                                  }
                              }
                             ]
                         }
                    ]
                }
        };
    };
    
    /**
     * Data part ---------------------------------
     */
    
    TemplateBuilder.prototype.basicNode = function( content, classes, attributes ){
        return {
            'nodeType':'td',
            'attributes': attributes,
            'classes' : classes,
            'content': content
        };
    };
    
    TemplateBuilder.prototype.imgNode = function( src, title, classes, attributes ){
        return {
            'nodeType' : 'td',
            'attributes': attributes,
            'content' : {
                'nodeType':'img',
                'classes': classes,
                'src': src,
                'title': title
            }
        };
    };
    
    TemplateBuilder.prototype.spanNode = function( content, classes, attributes ){
        return {
            'nodeType' : 'td',
            'attributes': attributes,
            'content' : {
                'nodeType':'span',
                'classes': classes,
                'content': content
            }
        };
    };
    
    TemplateBuilder.prototype.linkNode = function( href, content ){
        return {
            'nodeType':'td',
            'content': {
                'nodeType':'a',
                'href': href,
                'content': content
            }            
        };  
    };
    
    TemplateBuilder.prototype.booleanNode = function( switchField,  trueCaseClasses, falseCaseClasses ){
        return {
            'nodeType':'td',
            'content':
                {
                'attributes':{'align':'center'},
                'nodeType':'switch_case',
                'switchCaseField': switchField,
                'switchCase':
                    {
                    'true':
                        {
                        'nodeType':'span',
                        'classes': trueCaseClasses || ['icon-check','icon-large']
                        },
                    'false':
                        {
                        'nodeType':'span',
                        'classes': falseCaseClasses || ['icon-check-empty','icon-large']
                        }
                    }
                }
        }
    };
    
    return TemplateBuilder;
});
